/**
 * Do not edit directly
 * Generated on Thu, 20 Aug 2026 13:57:27 GMT
 */

const theme = {
  colors: {
    border: {
      primary: '#C9CFD4',
      secondary: '#D7DCE0',
      contrast: '#62686E',
      error: '#BA4632',
      caution: '#F3B86B',
      success: '#01845C',
      info: '#C9CFD4',
      highlight: '#156A73',
      input_focus: '#2E67D1',
    },
    brand: {
      rover: '#00BD70',
      catinaflat: '#F4715F',
      folder: '#D9D9D9',
      safety: '#2741CC',
      logo: '#F31E1E',
      facebook: '#3B5998',
      google: '#4285F4',
      instagram: '#8A3AB9',
      linkedin: '#0A66C2',
      tiktok: '#000000',
      youtube: '#FF0000',
      apple: '#000000',
      active_brand: '#F4715F',
    },
    neutral: {
      '100': '#F4F5F6',
      '200': '#E6E8EB',
      '300': '#D7DCE0',
      '400': '#C9CFD4',
      '500': '#9EA5AC',
      '600': '#767C82',
      '700': '#62686E',
      '800': '#404347',
      '900': '#1F2124',
      white: '#FFFFFF',
      black: '#000000',
    },
    green: {
      '100': '#EDFFF6',
      '200': '#BAEAD2',
      '300': '#5AD1A0',
      '400': '#19B682',
      '500': '#019C6D',
      '600': '#01845C',
      '700': '#0A6C4B',
      '800': '#16563D',
      '900': '#133829',
    },
    cyan: {
      '100': '#E9F8FA',
      '200': '#9DE0E9',
      '300': '#54CDDB',
      '400': '#3EB0BD',
      '500': '#479AA4',
      '600': '#117883',
      '700': '#156A73',
      '800': '#15545B',
      '900': '#07363B',
    },
    yellow: {
      '100': '#FCF6ED',
      '200': '#FAEDDD',
      '300': '#FCDAB1',
      '400': '#F3B86B',
      '500': '#D49234',
      '600': '#BA7C1A',
      '700': '#7F5516',
      '800': '#644418',
      '900': '#412D12',
    },
    blue: {
      '100': '#ECF1FB',
      '200': '#C5D5F2',
      '300': '#A3BDEB',
      '400': '#7DA1E2',
      '500': '#5685DA',
      '600': '#2E67D1',
      '700': '#2D5CB1',
      '800': '#24498C',
      '900': '#172F5B',
    },
    red: {
      '100': '#FFEAE6',
      '200': '#FFC5BB',
      '300': '#FFA293',
      '400': '#F4715F',
      '500': '#E05C44',
      '600': '#BA4632',
      '700': '#A1402F',
      '800': '#7C3324',
      '900': '#51231B',
    },
    orange: {
      '100': '#FCF5EF',
      '200': '#FFA96E',
      '300': '#FFA96E',
      '400': '#FF8A46',
      '500': '#FF7525',
      '600': '#E0621B',
      '700': '#BB4F12',
      '800': '#77320B',
      '900': '#331706',
    },
    pink: {
      '100': '#F7F4F5',
      '200': '#FDD7E8',
      '300': '#FAA5CE',
      '400': '#EA8BBA',
      '500': '#D582AB',
      '600': '#A46081',
      '700': '#593647',
      '800': '#4B2438',
      '900': '#29111E',
    },
    overlay: {
      background: 'rgba(31, 33, 36, 0.48)',
      accent: 'rgba(1, 156, 109, 0.24)',
    },
    interactive_text: {
      primary_base: '#404347',
      primary_active: '#593647',
      primary_pressed: '#29111E',
      destructive_base: '#BA4632',
      destructive_pressed: '#A1402F',
      destructive_inverse_base: '#F4715F',
      destructive_inverse_pressed: '#FFA293',
      disabled: '#9EA5AC',
    },
    interactive_link: {
      primary_base: '#117883',
      primary_pressed: '#15545B',
      primary_visited: '#117883',
      primary_inverse_base: '#54CDDB',
      primary_inverse_pressed: '#E9F8FA',
      primary_inverse_visited: '#54CDDB',
      secondary_base: '#593647',
      secondary_pressed: '#29111E',
      secondary_visited: '#593647',
      secondary_inverse_base: '#F7F4F5',
      secondary_inverse_pressed: '#FDD7E8',
      secondary_inverse_visited: '#F7F4F5',
    },
    interactive_border: {
      primary_base: '#C9CFD4',
      primary_pressed: '#767C82',
      primary_active: '#593647',
      primary_active_pressed: '#29111E',
      selected: '#2E67D1',
      disabled: '#E6E8EB',
      button_primary_base: '#767C82',
    },
    separator: {
      primary: '#D7DCE0',
    },
    text: {
      primary: '#1F2124',
      primary_inverse: '#FFFFFF',
      secondary: '#404347',
      secondary_inverse: '#F4F5F6',
      tertiary: '#62686E',
      tertiary_inverse: '#E6E8EB',
      display: '#E05C44',
      price: '#0A6C4B',
      error: '#BA4632',
      caution: '#644418',
      success: '#0A6C4B',
      navigation: '#FFFFFF',
      attention: '#BB4F12',
      attention_highlight: '#F3B86B',
      navigation_hover: '#D7DCE0',
      disabled: '#9EA5AC',
      placeholder: '#62686E',
    },
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#FCF6ED',
    tertiary: '#FAEDDD',
    contrast: '#593647',
    accent: '#FCF6ED',
    accent_secondary: '#ECF1FB',
    error: '#FFEAE6',
    caution: '#FCF6ED',
    success: '#EDFFF6',
    info: '#ECF1FB',
    highlight: '#E9F8FA',
    attention_blue: '#C5D5F2',
    attention_highlight: '#F3B86B',
    navigation: '#593647',
    overlay: 'rgba(31, 33, 36, 0.48)',
    overlay_accent: 'rgba(1, 156, 109, 0.24)',
    interactive: {
      primary_base: '#FFFFFF',
      primary_pressed: '#F4F5F6',
      primary_active: '#593647',
      primary_active_pressed: '#29111E',
      disabled: '#F4F5F6',
      destructive: '#BA4632',
      destructive_pressed: '#A1402F',
      button_primary_base: '#593647',
      button_primary_pressed: '#29111E',
      button_primary_inverse_base: '#F7F4F5',
      button_primary_inverse_pressed: '#FDD7E8',
      toggle_button_selected_base: '#FAEDDD',
      toggle_button_selected_hover: '#FCDAB1',
    },
  },
  space: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  sizes: {
    '-64x': '-256px',
    '-48x': '-192px',
    '-40x': '-160px',
    '-32x': '-128px',
    '-24x': '-96px',
    '-20x': '-80px',
    '-16x': '-64px',
    '-12x': '-48px',
    '-10x': '-40px',
    '-8x': '-32px',
    '-6x': '-24px',
    '-5x': '-20px',
    '-4x': '-16px',
    '-3x': '-12px',
    '-2x': '-8px',
    '-1x': '-4px',
    '0x': '0px',
    '1x': '4px',
    '2x': '8px',
    '3x': '12px',
    '4x': '16px',
    '5x': '20px',
    '6x': '24px',
    '8x': '32px',
    '10x': '40px',
    '12x': '48px',
    '16x': '64px',
    '20x': '80px',
    '24x': '96px',
    '32x': '128px',
    '40x': '160px',
    '48x': '192px',
    '64x': '256px',
  },
  radii: {
    square: '0px',
    primary: '8px',
    secondary: '4px',
    large: '16px',
    round: '99999px',
  },
  borderWidth: {
    primary: '2px',
    secondary: '1px',
  },
  shadows: {
    elevation_low: '0px 1px 4px 0px rgba(27, 31, 35, 0.24)',
    elevation_mid: '0px 2px 12px -1px rgba(27, 31, 35, 0.24)',
    elevation_high: '0px 8px 10px -6px rgba(27, 31, 35, 0.22)',
    border_primary: '0px 0px 0px 2px rgba(207, 215, 222, 1)',
    border_contrast: '0px 0px 0px 2px rgba(102, 114, 127, 1)',
    border_disabled: '0px 0px 0px 2px rgba(232, 235, 237, 1)',
  },
  fontWeight: {
    regular: '400 !important',
    semibold: '600 !important',
  },
  textColor: {
    primary: '#1F2124',
    primary_inverse: '#FFFFFF',
    secondary: '#404347',
    secondary_inverse: '#F4F5F6',
    tertiary: '#62686E',
    tertiary_inverse: '#E6E8EB',
    display: '#E05C44',
    price: '#0A6C4B',
    error: '#BA4632',
    caution: '#644418',
    success: '#0A6C4B',
    navigation: '#FFFFFF',
    attention: '#BB4F12',
    attention_highlight: '#F3B86B',
    navigation_hover: '#D7DCE0',
    disabled: '#9EA5AC',
    placeholder: '#62686E',
  },
  textAlign: {
    left: 'left',
    center: 'center',
    right: 'right',
  },
  textDecoration: {
    none: 'none',
    underline: 'underline',
    'line-through': 'line-through',
  },
  textTransform: {
    none: 'none',
    uppercase: 'uppercase',
  },
  variants: {
    card_default: {
      padding: '5x',
      boxShadow: 'elevation_mid',
      borderRadius: 'primary',
    },
    elevation_low: {
      boxShadow: 'elevation_low',
    },
    elevation_mid: {
      boxShadow: 'elevation_mid',
    },
    elevation_high: {
      boxShadow: 'elevation_high',
    },
  },
  buttons: {
    base: {
      borderRadius: 'round',
      borderWidth: '2px',
      borderColor: 'transparent',
      borderStyle: 'solid',
      cursor: 'pointer',
      bg: 'transparent',
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'antialiased',
      '&:hover,&:active': {
        textDecoration: 'none',
      },
    },
    disabled: {
      variant: 'buttons.base',
      color: '#9EA5AC',
      background: 'interactive.disabled',
      borderColor: 'interactive_border.disabled',
      cursor: 'not-allowed',
      '&:hover,&:active': {
        color: '#9EA5AC',
      },
    },
    secondary: {
      base: {
        variant: 'buttons.base',
        color: '#404347',
        background: 'interactive.primary_base',
        borderColor: 'interactive_border.button_primary_base',
        '&:hover,&:active': {
          color: '#404347',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'contrast',
        borderColor: 'border.contrast',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.secondary.base',
        color: '#BA4632',
        borderColor: 'border.error',
        '&:hover,&:active': {
          color: '#BA4632',
          background: 'error',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'interactive_text.destructive_inverse_base',
        borderColor: 'border.error',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
          backgroundColor: '#51231B',
        },
      },
    },
    primary: {
      base: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.button_primary_base',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.button_primary_pressed',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        background: 'interactive.destructive',
        boxShadow: 'elevation_mid',
        '&:hover,&:active': {
          color: '#FFFFFF',
          background: 'interactive.destructive_pressed',
        },
      },
    },
    flat: {
      base: {
        variant: 'buttons.base',
        color: 'interactive_link.primary_base',
        '&:hover,&:active': {
          color: 'interactive_link.primary_pressed',
          background: 'interactive.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.base',
        color: '#FFFFFF',
        '&:hover,&:active': {
          color: '#FFFFFF',
          backgroundColor: 'neutral.900',
        },
      },
      destructive: {
        variant: 'buttons.base',
        color: '#BA4632',
        '&:hover,&:active': {
          color: '#BA4632',
          backgroundColor: '#FFEAE6',
        },
      },
      contrastDestructive: {
        variant: 'buttons.base',
        color: 'interactive_text.destructive_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
          backgroundColor: '#51231B',
        },
      },
    },
    link: {
      base: {
        variant: 'buttons.base',
        color: 'interactive_link.primary_base',
        borderColor: 'transparent',
        borderWidth: '0',
        borderRadius: '0',
        display: 'inline',
        textDecoration: 'underline',
        '&:hover,&:active': {
          color: 'interactive_link.primary_pressed',
        },
      },
      contrast: {
        variant: 'buttons.link.base',
        color: 'interactive_link.primary_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_link.primary_inverse_pressed',
        },
      },
      destructive: {
        variant: 'buttons.link.base',
        color: 'interactive_text.destructive_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_pressed',
        },
      },
      contrastDestructive: {
        variant: 'buttons.link.base',
        color: 'interactive_text.destructive_inverse_base',
        '&:hover,&:active': {
          color: 'interactive_text.destructive_inverse_pressed',
        },
      },
    },
    link_disabled: {
      variant: 'buttons.link.base',
      color: 'interactive_text.disabled',
      cursor: 'not-allowed',
      '&:hover,&:active': {
        color: 'interactive_text.disabled',
      },
    },
  },
  text: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.2,
    },
  },
  paragraph: {
    '50': {
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '12px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '16px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: 1.5,
      marginBottom: '24px',
    },
  },
  heading: {
    '50': {
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '100': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '8px',
    },
    '200': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '12px',
    },
    '300': {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '16px',
    },
    '400': {
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontSize: '38px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  headingResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
  display: {
    '400': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '26px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '20px',
    },
    '500': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '24px',
    },
    '600': {
      fontFamily: 'Cat-in-a-Flat-Regular',
      fontSize: '38px',
      fontWeight: 600,
      lineHeight: 1.25,
      marginBottom: '32px',
    },
  },
  displayResponsive: {
    '400': {
      fontSize: '32px',
    },
    '500': {
      fontSize: '40px',
    },
    '600': {
      fontSize: '48px',
    },
  },
};

export default theme;

/** The entire theme object. */
export type Theme = typeof theme;

/** Theme color tokens organized by category */
export type Colors = Theme['colors'];
/** Theme background tokens */
export type Background = Theme['background'];
/** Union of all available background color keys from theme */
export type BackgroundColors =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'contrast'
  | 'accent'
  | 'accent_secondary'
  | 'error'
  | 'caution'
  | 'success'
  | 'info'
  | 'highlight'
  | 'attention_blue'
  | 'attention_highlight'
  | 'navigation'
  | 'overlay'
  | 'overlay_accent'
  | 'interactive.primary_base'
  | 'interactive.primary_pressed'
  | 'interactive.primary_active'
  | 'interactive.primary_active_pressed'
  | 'interactive.disabled'
  | 'interactive.destructive'
  | 'interactive.destructive_pressed'
  | 'interactive.button_primary_base'
  | 'interactive.button_primary_pressed'
  | 'interactive.button_primary_inverse_base'
  | 'interactive.button_primary_inverse_pressed'
  | 'interactive.toggle_button_selected_base'
  | 'interactive.toggle_button_selected_hover';
/** Interactive state background color keys (hover, active, disabled, etc.) */
export type InteractiveBackgroundColors = keyof Theme['background']['interactive'];
/** Theme spacing tokens ('1x', '2x', etc.) */
export type Spacing = keyof Theme['space'];
/** Theme border radius tokens */
export type Radii = keyof Theme['radii'];
/** Theme font weight tokens */
export type FontWeight = keyof Theme['fontWeight'];
/** Theme text alignment values */
export type TextAlign = keyof Theme['textAlign'];
/** Theme text color tokens */
export type TextColor = keyof Theme['textColor'];
/** Theme text decoration values */
export type TextDecoration = keyof Theme['textDecoration'];
/** Theme text transform values */
export type TextTransform = keyof Theme['textTransform'];
export const HEADING_SIZES = ['50', '100', '200', '300', '400', '500', '600'];
/** Theme heading size tokens (50, 100, 200, 300, 400, 500, or 600) */
export type HeadingSizes = (typeof HEADING_SIZES)[number];
export const RESPONSIVE_HEADING_SIZES = ['400', '500', '600'];
/** Theme responsive heading size tokens */
export type ResponsiveHeadingSizes = (typeof RESPONSIVE_HEADING_SIZES)[number];
export const DISPLAY_SIZES = ['400', '500', '600'];
/** Theme display size tokens (400, 500, or 600) */
export type DisplaySizes = (typeof DISPLAY_SIZES)[number];
export const RESPONSIVE_DISPLAY_SIZES = ['400', '500', '600'];
/** Theme responsive display size tokens */
export type ResponsiveDisplaySizes = (typeof RESPONSIVE_DISPLAY_SIZES)[number];
export const PARAGRAPH_SIZES = ['50', '100', '200', '300'];
/** Theme paragraph size tokens (50, 100, 200, or 300) */
export type ParagraphSizes = (typeof PARAGRAPH_SIZES)[number];
export const TEXT_SIZES = ['50', '100', '200', '300'];
/** Theme text size tokens (50, 100, 200, or 300) */
export type TextSizes = (typeof TEXT_SIZES)[number];
